import EForm from './e-type-form.js'
import IFrameActive from './iframe-active'
import VLockOverlay from './lock-overlay'

export default {
  'e-form': EForm,
  'iframe-active': IFrameActive,
  'lock-overlay': VLockOverlay
}
